import React from 'react';
import { Box, Container, Heading, Text, VStack } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const NationalitePage = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Header />
      <Box as="main" flex="1">
        <Container maxW="1200px" px={5} py={{ base: 12, lg: 16 }}>
          <VStack align="start" spacing={4}>
            <Heading size="xl">Nationalité française</Heading>
            <Text color="gray.600">Informations et accompagnement pour vos demandes de nationalité.</Text>
          </VStack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default NationalitePage;


